var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-10"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(this.title))]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(this.subtitle)+" "+_vm._s(this.totalPrefix)+" "+_vm._s(this.total)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }